import axios from 'axios';
import { BaseResponse } from '../Models/baseResponse';
import { CompatibilityResult} from '../Models/compatibilityResult';
import { VerificationRequest } from '../Models/VerificationRequest';
import { MpaRequest } from "../Models/mpaRequest";
import { Enquiry } from '../Models/Enquiry';
import { getEnvConfig } from '../utils/envConfig';
import FactSheetMetaData from '../Models/FactSheetMetadata';

const envConfig = getEnvConfig();

const ApiService = {
  sendCompatibilityResult: (result: CompatibilityResult) => {
    return axios.post<CompatibilityResult>(
      `${envConfig.BackendApiUrl}/odata/compatibilitycheck`,
      result,
    );
  },
  checkVerificationCode: (code: VerificationRequest) => {
    return axios.post<BaseResponse>(
      `${envConfig.BackendApiUrl}/portal/v1/mpa/verification`, 
      code,
    );
  },
  sendContactUsForm: (enquiry: Enquiry) => {
    return axios.post<Enquiry>(
      `${envConfig.BackendApiUrl}/portal/v1/enquiry`,
      enquiry,
    );
  },
  sendMpa: ( mpaData: MpaRequest) => {
    return axios.post<BaseResponse>(
      `${envConfig.BackendApiUrl}/portal/v1/mpa`,
      mpaData,
    );
  },
  getFactSheetMetadata: ( factSheetName: string) => {
    return axios.get<FactSheetMetaData>(`${envConfig.BackendApiUrl}/odata/factsheet?$filter=name eq '${factSheetName}'`);
  }
}

export default ApiService;
